import { SeverityLevel } from '@logz-pkg/enums';
export class AlertSeverityThresholdModel {
    severityLevel = SeverityLevel.Medium;
    threshold = 0;
    riskScore;
}
//# sourceMappingURL=alert-severity-threshold.js.map